import { trackEvent } from '@host/utils/posthog-track';

// Guests are not identified in PostHog, so guest-side events are anonymous. Guest names and
// emails are never sent. Invites are tracked where they are sent (InviteGuestModal).

/** Where a host acted on a guest from; bulk "… all" actions send one event per guest. */
export type GuestActionSource = 'toast' | 'waiting_list' | 'waiting_list_bulk';

export type GuestHostAction = 'summoned' | 'sent_to_lobby' | 'transferred' | 'declined';

export const trackGuestHostAction = (action: GuestHostAction, source: GuestActionSource) => {
  trackEvent(`guest_${action}`, { source });
};

export const trackGuestInviteOpened = () => trackEvent('guest_invite_opened');

export const trackGuestJoinedViaInvite = () => trackEvent('guest_joined_via_invite');

/** Phones and tablets get dial-in instructions instead of joining in the browser. */
export const trackGuestDialInShown = () => trackEvent('guest_dial_in_shown');

export const trackGuestCheckedIn = () => trackEvent('guest_checked_in');
